export const getUserLabel = (user) => {
    if (!user) return '';
    const name = [user.first_name, user.last_name].filter(Boolean).join(' ').trim();
    if (name) return name;
    return user.email || '';
};

// «Фамилия Имя» — для списков сотрудников, где рядом показывается почта.
export const formatUserFullName = (user) => {
    if (!user) return '';
    return [user.last_name, user.first_name].filter(Boolean).join(' ').trim();
};

export const getUserInitials = (user) => {
    if (!user) return '';
    const first = (user.first_name || '').trim();
    const last = (user.last_name || '').trim();
    const initials = `${first.charAt(0)}${last.charAt(0)}`.toUpperCase();
    if (initials.trim()) return initials;
    return (user.email || '?').charAt(0).toUpperCase();
};

export const getInitials = (value) => {
    if (!value) return '';
    if (typeof value === 'string') {
        const parts = value.trim().split(' ').filter(Boolean);
        if (!parts.length) return '';
        if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
        return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase();
    }
    return getUserInitials(value);
};
